<template>
  <div>
    <SettingsModal
      v-if="isSettingsModalVisible"
      @close="INTRO_SET_SETTINGS_MODAL_VISIBLE(false)"
    ></SettingsModal>
    <!-- Debug: {{ isAutoReportsSettingsVisible }} -->
    <AutoReportSettings
      v-if="isAutoReportsSettingsVisible"
      @close="INTRO_SET_AUTOREPORTS_SETTINGS_VISIBLE(false)"
    ></AutoReportSettings>
    <AddPage v-if="isAddPageVisible" @close="INTRO_SET_ADD_PAGE_VISIBLE(false)"></AddPage>
    <!-- <AccessManager v-if="isAccessManagerVisible" @close="INTRO_SET_ACCESS_MANAGER_VISIBLE(false)"></AccessManager> -->
    <CategoryManager v-if="isCategoriesManagerVisible"></CategoryManager>
    <CreateCategory v-if="isCategoriesCreateVisible"></CreateCategory>
  </div>
</template>

<script>
import AddPage from "./AddPage";
import AutoReportSettings from "./AutoReportSettings";
import AccessManager from "./AccessManager";
import SettingsModal from "./Settings";
import CategoryManager from "./CategoryManager";
import CreateCategory from "./CreateCategory";
import { mapGetters, mapMutations } from "vuex";
import {
  INTRO_SET_ACCESS_MANAGER_VISIBLE,
  INTRO_SET_AUTOREPORTS_SETTINGS_VISIBLE,
  INTRO_SET_ADD_PAGE_VISIBLE,
  INTRO_SET_SETTINGS_MODAL_VISIBLE
} from "../../store/actions/intro";

export default {
  name: "Modals",
  components: {
    AddPage,
    AutoReportSettings,
    AccessManager,
    SettingsModal,
    CategoryManager,
    CreateCategory
  },
  computed: {
    ...mapGetters([
      "isAddPageVisible",
      "isAccessManagerVisible",
      "isAutoReportsSettingsVisible",
      "isSettingsModalVisible",
      "isCategoriesManagerVisible",
      "isCategoriesCreateVisible"
    ])
  },
  methods: {
    ...mapMutations([
      INTRO_SET_ACCESS_MANAGER_VISIBLE,
      INTRO_SET_AUTOREPORTS_SETTINGS_VISIBLE,
      INTRO_SET_ADD_PAGE_VISIBLE,
      INTRO_SET_SETTINGS_MODAL_VISIBLE
    ])
  }
};
</script>

<style>
</style>